import { useTranslation } from "react-i18next";
import { ACTION_STATUS } from "constants/actions";
import { ACTION_VIEW_MODE } from "constants/action-form";
import Title from "../../../Typography/Title";
import DateSpan from "../date-span/DateSpan";
import ActionModalDescriptionSection from "../description/ActionModalDescriptionSection";

const OtherActionSuggestion = ({ viewMode, isFullWidth, isProposedValue, isNewVersion }) => {
  const { t } = useTranslation();
  const status = ACTION_STATUS.suggested;
  const isViewMode = viewMode === ACTION_VIEW_MODE.view;
  return (
    <div className="action-modal-card action-details-box ">
      <div className={isFullWidth && "details-half-width"}>
        <Title title={t("ActionModal.Details.Suggested")} />
        {!isNewVersion && <DateSpan viewMode={viewMode} status={status} />}
        <ActionModalDescriptionSection
          task="other"
          isViewMode={isViewMode}
          isProposed={isProposedValue}
          isNewVersion={isNewVersion}
        />
      </div>
    </div>
  );
};
export default OtherActionSuggestion;
